var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M29 18.714H18.714V29h-3.428V18.714H5v-3.428h10.286V5h3.429v10.286H29z","transform":"translate(-5 -5)"}));
}

IconPlus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
